import React from 'react';
import useStyles from './styles';

function Button({children, onClick, type, className, disabled, title}) {
  const c = useStyles();

  return(
    <button 
    title={title || ""}
    disabled={disabled || false}
    type={type || "button"}
    onClick={(e) => {onClick && onClick(e)}} 
    className={c.btn + " " + (className || "")}>

      {children}
    </button>
  )
}

export default Button;